import type { PixelEventsCheckoutStarted } from "@shopify/web-pixels-extension";
import * as z from "zod";

const shopifyCheckoutSchema_ = z.any().transform(
  (val: any) =>
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    val as Omit<
      PixelEventsCheckoutStarted["data"]["checkout"],
      "lineItems" | "subtotalPrice" | "totalPrice" | "totalTax" | "shippingLine"
    > & {
      // don't trust shopify types - sometimes their events omit lineItems
      lineItems?: PixelEventsCheckoutStarted["data"]["checkout"]["lineItems"];
      subtotalPrice:
        | PixelEventsCheckoutStarted["data"]["checkout"]["subtotalPrice"]
        | null;
      totalPrice:
        | PixelEventsCheckoutStarted["data"]["checkout"]["totalPrice"]
        | null;
      totalTax:
        | PixelEventsCheckoutStarted["data"]["checkout"]["totalTax"]
        | null;
      shippingLine:
        | PixelEventsCheckoutStarted["data"]["checkout"]["shippingLine"]
        | null;
    },
);
export const shopifyCheckoutSchema: z.ZodType<RobustCheckout> =
  shopifyCheckoutSchema_;
export type RobustCheckout = z.infer<typeof shopifyCheckoutSchema_>;
